import { IScoSystem } from 'src/app/models/scosystem.interface';
import { Action } from '@ngrx/store';

export enum EScoSystemActions {
    AddScoSystem = '[ScoSystem] Add ScoSystem',
    DelScoSystem = '[ScoSystem] Del ScoSystem'
  }

  export class AddScoSystem implements Action {
    public readonly type = EScoSystemActions.AddScoSystem;
    constructor(public payload: IScoSystem) {}
  }


  export class DelScoSystem implements Action {
    public readonly type = EScoSystemActions.DelScoSystem;
  }

  export type ScoSystemActions =
    | AddScoSystem
    | DelScoSystem;
